import { AutenticacionService } from './autenticacion.service';
import { Http, ResponseContentType } from '@angular/http';
import { Injectable } from '@angular/core';
import { ConstantsService } from './constants.service';

@Injectable()
export class ReporteEquilibrioKRService {
  public api_url: string;
  public modulo_url: string;
  public service_url: string;
  constructor(private http: Http, private authService: AutenticacionService, private constantService: ConstantsService) {
    this.api_url = this.constantService.apiURL;
    this.modulo_url = '/reportes/reporte-punto-equilibrio-kr';
    this.service_url = this.api_url + this.modulo_url;
  }

  getReporte(fechaInicial, fechaFinal,idObras = 13) {
    return this.http.get(this.service_url + '?fechaInicial=' + fechaInicial + '&fechaFinal=' + fechaFinal + '&idObras=' + idObras, this.authService.getAuthHeaders());
  }

  getMovimientos(idConceptos, fechaInicial, fechaFinal, idObra =13) {
    return this.http.get(this.service_url + '/movimientos?filter='+idObra+'||' + idConceptos +'|||'+fechaInicial+'|'+fechaFinal, this.authService.getAuthHeaders());
  }

}



// WEBPACK FOOTER //
// ./src/app/services/reporte-equilibrio-kr.service.ts